import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var AccordionFilters = function AccordionFilters() {
  Alpine.data('AccordionFilters', function () {
    return {
      tags: [],
      isSelected: function isSelected(tag) {
        var _this = this;
        return tag.some(function (x) {
          return _this.tags.includes(x);
        });
      }
    };
  });
};